import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import { EventsAndInvitesViewState } from '../../store/schema/EventsAndInvitesViewState';
import { getOptionsStore } from '../../store/Store';
import { initEventsAndInvitesOption } from '../../actions/eventsAndInvites/initEventsAndInvitesOption';
import { mutator } from 'satcheljs';
import {
    getEffectiveShouldEventsEndEarly,
    getEffectiveEndShortEventsBy,
    getEffectiveEnableOnlineMeetingsByDefault,
    getEffectiveEndLongEventsBy,
} from 'mini-calendar-cloud-settings';

export const initEventsAndInvitesOptionMutator = mutator(initEventsAndInvitesOption, () => {
    const activeViewState: EventsAndInvitesViewState = {
        name: ActiveItem.EventsAndInvites,
        isDirty: false,
        isLoading: false,
        shouldEventsEndEarly: getEffectiveShouldEventsEndEarly(),
        endShortEventsBy: getEffectiveEndShortEventsBy(),
        endLongEventsBy: getEffectiveEndLongEventsBy(),
        enableOnlineMeetingsByDefault: getEffectiveEnableOnlineMeetingsByDefault(),
    };
    getOptionsStore().activeViewState = activeViewState as ActiveOptionViewState;
});
